export const authTokensKey = "arachnys:auth";

interface ITokenObject {
    __typename: "Token";
    exp: number;
    first_name: string;
    is_admin: boolean;
    jti: string;
    last_name: string;
    raw: string;
    requires_2fa_setup: boolean;
    switched_from: number | null;
    token_type: string;
    user_id: number;
    username: string;
}

export interface IAuthObject {
    __typename: "Auth";
    accessToken: ITokenObject;
    refreshToken: ITokenObject;
}

export const deleteAuthObject = (): void =>
    localStorage.removeItem(authTokensKey);

export const getAuthObject = (): IAuthObject | void => {
    const storedTokens = localStorage.getItem(authTokensKey);
    if (!storedTokens) return;
    try {
        return JSON.parse(storedTokens);
    } catch {
        deleteAuthObject();
    }
};

export const setAuthObject = (tokens: IAuthObject): void =>
    localStorage.setItem(authTokensKey, JSON.stringify(tokens));
